import { render, staticRenderFns } from "./NavigationManage.vue?vue&type=template&id=33cea5de&scoped=true"
import script from "./NavigationManage.vue?vue&type=script&lang=js"
export * from "./NavigationManage.vue?vue&type=script&lang=js"
import style0 from "./NavigationManage.vue?vue&type=style&index=0&id=33cea5de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33cea5de",
  null
  
)

export default component.exports